import { normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("canvas", {
    ref: "pieCanvas",
    style: _normalizeStyle([{"height":"100%","width":"100%"}, $props.stylePieChart])
  }, null, 4))
}